<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/aktivitetslogg">Aktivitetslogg</router-link>
        <router-link tag="li" to="/grafer">Grafer</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
    
    <!-- Filter -->
    <vue-tabs @tab-change="handleTabChange" centered>
      <v-tab title="Viktiga händelser"></v-tab>
      <v-tab title="Ej viktiga"></v-tab>
    </vue-tabs>

    <div style="padding-left:12px;padding-right:12px;">
      <div>
        <button @click="showFilter = !showFilter">{{ showFilter ? 'Dölj' : 'Visa' }} filteralternativ</button>
      </div>
      
      <div v-if="showFilter">
        <hr class="space">
        <select :disabled="loading" v-model.number="filter.nodeId" @change="load">
          <option value="0" selected>Alla enheter</option>
          <option v-for="node in $root.data.nodes" :value="node.id">{{ node.name || 'Inget namn' }}</option>
        </select>
        
        <hr class="space">
        
        <select v-if="!filter.nodeId" :disabled="loading" v-model="filter.capabilities" @change="load" multiple style="height:150px;">
          <option value="0" selected>Alla typer</option>
          <option v-for="(value, key) in $root.capabilities" :value="key">{{ $root.capabilities[key].name }}</option>
        </select>
        
        <select v-if="filter.nodeId" :disabled="loading" v-model="filter.capabilities" @change="load" multiple style="height:150px;">
          <option value="0" selected>Alla typer</option>
          <option v-for="key in $root.data.nodes.find(node => node.id === filter.nodeId).capabilities" v-if="key in $root.capabilities" :value="key">{{ $root.capabilities[key].name }}</option>
        </select>
        
        <p class="descr">Ovanför kan du filtrera din aktivitetslogg på enhet samt olika typer, exempelvis rörelsevakter samt magnetkontakter.</p>
      </div>
      
      <!-- Laddningsindikatorn -->
      <div v-if="loading" style="margin-top:2em;">
        <loading-view></loading-view>
      </div>
      	
      <!-- Visa tabellen om vi har laddat --> 
      <div v-if="!loading">
        <hr class="space">
  
        <table v-if="items.length">
          <thead>
            <tr>
              <th>Tid</th>
              <th>Enhet</th>
              <th>Namn</th>
              <th align="right">Värde</th>
            </tr>
          </thead>
    
          <tbody>
            <tr class="nohover" v-for="item in items" v-if="item.name in $root.capabilities">
              <td width="175">{{ item.time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
              <td width="350">{{ trim(getNodeName(item.sourceNode), 20) }}</td>
              <td>{{ $root.capabilities[item.name].name }}</td>
              <td align="right">
                <div v-if="$root.capabilities[item.name].type == 'number'">
                 {{ item.value }}{{ $root.capabilities[item.name].unit }}
                </div>
                <div v-else-if="$root.capabilities[item.name].type == 'boolean'">
                  {{ $root.capabilities[item.name].values[item.value].name }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js'
  import { VueTabs, VTab } from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/paper.css'
  import loadingView from './views/loadingView'

export default {
  name: 'HelloWorld',
  components: {
    VueTabs, 
    VTab, 
    loadingView
  },
  data () {
    return {
      items: [],
      timer: null,
      filter: {
        nodeId: 0,
        capabilities: []
      },
      loading: false,
      showFilter: false
    }
  },
  created () {    
    let caps = []
    for (let cap in this.$root.capabilities) {
      const capability = this.$root.capabilities[cap]
      capability.important && caps.push(cap)
    }
    
    this.filter.capabilities = caps
    this.load()

    eventbus.$on('nodeEvent', json => {
      let newArray = this.items.slice()
      newArray.unshift(json)
      this.items = newArray
    })
  },

  methods: {
    handleTabChange (tabIndex) {
      let levels = []
      
      // Hämtar ut definierade capaiblities i main.js och sorterar
      // dessa efter viktiga samt ej viktiga så vi kal filtrera på
      // detta lite senare.
      for (let cap in this.$root.capabilities) {
        const capability = this.$root.capabilities[cap]
        levels.push({
          name: cap,
          important: capability.important
        })
      }

      const caps = {
        0: levels.filter(cap => cap.important).map(cap => cap.name),
        1: levels.filter(cap => !cap.important).map(cap => cap.name)
      }
      
      this.filter.capabilities = caps[tabIndex]
      this.load()
    },
    
    load () {
      this.loading = true 
      
      let whereArray = []
      let whereString = ''
      
      if (this.filter.capabilities && this.filter.capabilities.length) {
        whereArray.push('(' + this.filter.capabilities.map(cap => 'name=\'' + cap + '\'').join(' or ') + ')')
      }
      
      if (this.filter.nodeId) {
        whereArray.push('sourceNode=' + this.filter.nodeId)
      }
      
      if (whereArray.length) {
        whereString = '?where=' + whereArray.join(' and ')
      }
      
      console.log(whereString)
                  
      HTTP.get('eventlog' + whereString)
      .then(res => res.data)
      .then(json => {
        this.items = json
        this.loading = false
      })
    },
    
    trim (string, length) {
      return string.length >= length ? string.substr(0, length) + '...' : string
    },
    
    getNodeName (sourceNode) {
      const node = this.$root.data.nodes.find(node => node.id === sourceNode)
      return node ? node.name : 'Okänd enhet'
    }
  },

  destroyed () {
    // När sidan förstörs slutar vi ladda om aktivitetsloggen
    // var 5e sekund.
    clearInterval(this.timer)
    eventbus.$off()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/aktivitetslogg.vue